import ECPay from "./ecpay";
import PowerTranz from "./powertranz";
import Xendit from "./xendit";
import StripeForm from "./stripe";
import Redirect from "./redirect";

const ComponentMapper = {
  ecpay: ECPay,
  powertranz: PowerTranz,
  xendit: Xendit,
  stripe: StripeForm,
};

export const getComponentForEnumValue = (enumValue) => {
  return ComponentMapper[enumValue.toLowerCase()] || Redirect;
};
